const mapperActionPlanToAPI = (form, paramId) => {
    const { title, tags, dueDate, budget, description } = form

    return {
        title,
        tag_id: tags.map((tag) => tag.value),
        due_date: dueDate,
        budget,
        pdi_id: paramId,
        description,
    }
}

export { mapperActionPlanToAPI }
